import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';
import _intersection from 'lodash/intersection';

const CAN_MANAGE_AUTHZ_PERMISSIONS = [
  Permission.ACCOUNT_MANAGEMENT_LOCATION_GROUP_CREATE,
  Permission.ACCOUNT_MANAGEMENT_LOCATION_GROUP_READ,
  Permission.ACCOUNT_MANAGEMENT_LOCATION_GROUP_UPDATE,
  Permission.ACCOUNT_MANAGEMENT_LOCATION_GROUP_DELETE,
];

export default class LocationsGroupingAbility extends Ability {
  @service declare currentAdmin: CurrentAdminService;
  @service declare state: StateService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare authz: AuthzService;

  get canManage(): boolean {
    return (
      !!this.state.features?.canAccessLocationsGrouping &&
      this.authz.hasAllPermissionsAtCurrentCompany(CAN_MANAGE_AUTHZ_PERMISSIONS)
    );
  }

  get canView(): boolean {
    return (
      !!this.state.features?.canAccessLocationsGrouping &&
      (this.authz.hasPermissionAtCurrentCompany(Permission.ACCOUNT_MANAGEMENT_LOCATION_GROUP_READ) ||
        this.authz.hasPermissionAtCurrentLocation(Permission.ACCOUNT_MANAGEMENT_LOCATION_GROUP_READ))
    );
  }
}
